export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فحص مكافحة غسل الأموال"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوانًا واختر البلوك تشين — سنقوم بإجراء فحص سريع."])}
}